import * as ConfigReducer from './ConfigReducer.js';
import * as ConfigActions from './ConfigActions.js';
import * as ConfigSelectors from './ConfigSelectors.js';

export {
  ConfigReducer,
  ConfigActions,
  ConfigSelectors
}


// WEBPACK FOOTER //
// ./src/modules/config/index.js